import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

interface CsrfResponse {
  success: boolean;
  data: { csrfToken: string };
}

@Injectable({ providedIn: 'root' })
export class CsrfService {
  private readonly http = inject(HttpClient);
  private token: string | null = null;
  private pending: Promise<string | null> | null = null;

  getCachedToken(): string | null {
    return this.token;
  }

  ensureToken(): Promise<string | null> {
    if (this.token) return Promise.resolve(this.token);
    if (this.pending) return this.pending;

    this.pending = firstValueFrom(
      this.http.get<CsrfResponse>(`${environment.apiUrl}/auth/csrf`)
    )
      .then(res => {
        this.token   = res.data.csrfToken;
        this.pending = null;
        return this.token;
      })
      .catch(() => {
        this.pending = null;
        return null;
      });

    return this.pending;
  }

  clear(): void {
    this.token = null;
  }
}
